 
import React from 'react';

interface IUnknownMonitorProps {
    color?: string;
}

const UnknownMonitor: React.FC<IUnknownMonitorProps> = ({color = '#899696'}) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="8" fill={color} />
            <circle cx="8" cy="8" r="4" fill="white"/>
        </svg>
    );
};

export default UnknownMonitor;